import { detect } from 'detect-browser'
import { atom } from 'jotai'
import { atomWithImmer } from 'jotai-immer'
import { HTMLProps } from 'react'

type FloatingElementState = {
  id: string | null
  shown: boolean
  contents: JSX.Element | null
  wasCreatedWithArgs: boolean
}

export type NotificationType = 'success' | 'info' | 'warning' | 'error'

export type Action = {
  title: string
  action: () => void
}

export type Notification = {
  id: number
  type: NotificationType
  title: string
  message?: string
  primaryLink?: { title: string; props: HTMLProps<HTMLAnchorElement> }
  primaryButton?: Action
  secondaryButton?: Action
  isHovered?: boolean
  notificationType: 'toast' | 'notification'
}

export const currentModalAtom = atomWithImmer<FloatingElementState>({
  id: null,
  shown: false,
  wasCreatedWithArgs: false,
  contents: null,
})
export const notificationsAtom = atomWithImmer<Notification[]>([])

export const browserInfoAtom = atom(() => detect())
